import React, { useEffect, useState } from "react";
import CollectiblesCard from "../../../../components/organizer/assets/collectibles-card/collectibles-card";
import { Button } from "../../../../components/styled-components/button";
import "../../../../components/form/inventory/inventory.style.css";
import { MODULE_API } from "../../../../apis";
import * as Style from "./styles/collectibles";
import Loader from "../../../styled-components/loader/loader";
import DEATH_API from "../../../../apis/death.api";

function Collectibles({ showCollectibleItems }) {
  const [allCollectibles, setAllCollectibles] = useState();
  const [CollectiblesCount, setCollectiblesCount] = useState();

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    // fetchCollectibles();
    // getCollectablesCounts();
    callListingCount();
  }, []);

  const callListingCount=async()=>{
    await fetchCollectibles();
    await getCollectablesCounts();
  }

  const fetchCollectibles = async () => {
    try {
      setIsLoading(true);
      let collectibles = await MODULE_API.fetchAll({
        pageNum: 1,
        limit: 40,
      });

      if (collectibles.status === 200) {
        setIsLoading(false);
        setAllCollectibles(collectibles.body);
      }
    } catch (e) {
      setIsLoading(false);

      console.log(e);
    }
  };

  const getCollectablesCounts= async ()=>{
    try {
      setIsLoading(true);
      let collectibles = await DEATH_API.GetCollectablesCount();
      if (collectibles.status === 200) {
        setCollectiblesCount(collectibles.countsPerModule)
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);

      console.log(e);
    }
  }

  return (
    <>
      {/* {isLoading ? <div class="loader" ng-hide="data.length > 0"></div> : null} */}
      <Style.HeaderContainer>
        <div>
          <Style.Title>Collectibles</Style.Title>
        </div>
        <Button
          style={{ background: "#2A3DA3", borderRadius: "8px" }}
          onClick={fetchCollectibles}
        >
          Sync Data
        </Button>
      </Style.HeaderContainer>
      <Style.CardContainer>
        {allCollectibles && 
          allCollectibles.map((data, index) => {
            const collectibleCountObject =CollectiblesCount && CollectiblesCount.find(
              item => item.moduleName === `${data.name}_item`
            );
        
            // Get the count if the object is found, otherwise default to 0
            const collectibleCount = collectibleCountObject ? collectibleCountObject.count : 0;
            return(
            <CollectiblesCard
              key={index + 1}
              data={data}
              count={collectibleCount}
              showCollectibleItems={showCollectibleItems}
            />
            )
            })}
      </Style.CardContainer>
      <Loader isLoading={isLoading} />
    </>
  );
}

export default Collectibles;
